module.exports = __webpack_public_path__ + "img/oft_sltch.e4ba814d.png";